import { Box, Button, Link, Tooltip } from '@material-ui/core';

export const ViewAnalysisButton = ({ signedUrl }: { signedUrl: string }) => {
  if (!signedUrl) {
    return (
      <Tooltip title="Analysis link is broken" arrow placement="right">
        <Box style={{ cursor: 'pointer' }}>
          <Button disabled>View full analysis here</Button>
        </Box>
      </Tooltip>
    );
  }

  return (
    <Link href={signedUrl} target="_blank" rel="noopener noreferrer">
      View full analysis
    </Link>
  );
};
